import { Breadcrumb } from "antd";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import { articles } from "../../api";
import styles from "./privacyPolicy.module.scss";

const PrivacyPolicy = () => {
  const { t, i18n } = useTranslation(["common"]);
  const [policy, setPolicy] = useState<any>("");
  const history = useHistory();

  useEffect(() => {
    async function fetchData() {
      try {
        const res = await articles();
        if (res.status === "success") {
          setPolicy(res.data[1]);
        }
      } catch (e) {
        throw e;
      }
    }
    fetchData();
  }, [i18n.language]);

  return (
    <section className={styles.policy}>
      <div className="container mx-auto">
        <Breadcrumb separator=">">
          <Breadcrumb.Item>
            <a
              className={styles.breadcrumb__link}
              onClick={() => {
                history.push("/");
              }}
            >
              {t("common:Trang chủ")}
            </a>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <span className={styles.breadcrumb__active}>
              {t("common:Chính sách bảo mật")}
            </span>
          </Breadcrumb.Item>
        </Breadcrumb>
        <div className={styles.policy__body}>
          <h2 className={styles.title}>{policy.title}</h2>
          <div dangerouslySetInnerHTML={{ __html: policy.content }} />
        </div>
      </div>
    </section>
  );
};

export default PrivacyPolicy;
